import React from "react";
import { useOutletContext, Link } from "react-router-dom";

export default function AdminHome() {
  const { stats } = useOutletContext();
  return (
    <div data-testid="admin-overview">
      <h2 className="text-2xl font-medium">Overview</h2>
      <p className="mt-2 text-slate-400 text-sm">Welcome back. Here&apos;s a snapshot of operations.</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-5">
        <Link to="/admin/products" className="border border-white/5 p-6 hover:border-cyan-500/40 transition group">
          <div className="label-mono text-cyan-400 mb-2">/ Catalog</div>
          <div className="text-lg font-medium">Manage products</div>
          <p className="text-sm text-slate-400 mt-2">Create, edit, and update inventory. {stats?.products_count} active SKUs.</p>
        </Link>
        <Link to="/admin/orders" className="border border-white/5 p-6 hover:border-cyan-500/40 transition group">
          <div className="label-mono text-cyan-400 mb-2">/ Fulfillment</div>
          <div className="text-lg font-medium">Process orders</div>
          <p className="text-sm text-slate-400 mt-2">{stats?.paid_orders} paid orders ready to ship.</p>
        </Link>
      </div>
    </div>
  );
}
